// import React from 'react';
// import {graphql} from 'react-apollo';
// import {flowRight as compose} from 'lodash';

// import queries from '../../../../../src/utils/queries'

import claseServCli from '../../../../functions/claseservcli';
import getNumDiasMes from '../../../../functions/getnumdiasmes';
import updColeccSI_ID from '../../../../functions/updColeccSI_ID';
import updColeccMANY from '../../../../functions/updColeccMANY';
import argsHc from '../../../../functions/argshc';

import rpvalidar from './rpvalidar';
import rpArgsMvp from './rpargsmvp';
import rpArgsPc from './rpargspc';
import rpArgsMc from './rpargsmc';
import rpArgsRx from './rpargsrx';


// import jsPDF from 'jspdf';
// import 'jspdf-autotable';

const MainRdo = async (elementoArchRdo, clienteSel, listColeccRP, listColeccRPCC, numeroDocum, descrRecurso,
    ultMF, editSeqfindOneAndUpdate, createPagoClientes, editPagoClientesUpdDoc, createHistClienteMany,
    createMovClientesMany, createMovCliCCMany, editClienteMany, editClienteUpdDocMany,
    editMovClientes, editCliente, editRdoTerc, createAjuste, createMovClientes, descrOficina,
    ajCero, fechaHoraHoy, valorparaPermRX) => {
// console.log(clienteSel.contrato, valorparaPermRX)
  const nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  //ACTUALIZAR BD
  const crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
        const {data} = await operacionCRUD({
        variables: args
      });
//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        await operacionCRUD({
          variables: args
        });
      }
    }
  }

  const updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
      let codigo = 0
      if(argsCrud[0].ctrl_id === 'SI_ID'){
        codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
      }else{
        await crudBD(crudColecc[0], argsCrud[0], 0)
      }
      if(codigo!==0){
        for(let i=1; i<totDocCRUD; i++){
          argsCrud[i]._id = codigo
        }
      }
      for(let i=1; i<totDocCRUD; i++){
        await crudBD(crudColecc[i], argsCrud[i], i)
      }
    }

  let data = clienteSel
  let dataChange = {descrOficina, contrato: data.contrato, valorEf: parseInt(elementoArchRdo.valorTotal, 10), numeroRT: null}
  let totRecibido = elementoArchRdo.valorTotal
  let saldoPendiente = clienteSel.saldoPendiente
  let numeroDocumUA = numeroDocum
// console.log(listColeccRP, data, dataChange, totRecibido, saldoPendiente, numeroDocumUA)
  let totRecib = totRecibido
  let listServTar = listColeccRP.map(recpago => ({...recpago}))
  listServTar.forEach((elemento, i) => {
    if(elemento.valorTotal<0){
      totRecib -= elemento.valorTotal
      listServTar[i].valorRecibido = elemento.valorTotal
    }
  })

  listServTar.forEach((elemento, i) => {
    if(elemento.valorTotal>0){
      if(totRecib > elemento.valorTotal - elemento.valorPagado){
        totRecib -= (elemento.valorTotal - elemento.valorPagado)
        listServTar[i].valorRecibido = elemento.valorTotal - elemento.valorPagado
      }else{
        listServTar[i].valorRecibido = totRecib
        totRecib = 0
      }
    }
  })
  // console.log(listServTar)

  totRecib = 0
  listServTar.forEach((elemento, i) => {
    totRecib += parseInt(elemento.valorRecibido, 10)
  })

  let validado = rpvalidar(dataChange, totRecibido, totRecib, saldoPendiente)
  // console.log(validado)
  if(validado.length===0){
    let userLogin = sessionStorage.getItem('userLogin')
    let numDocCRUD = 0, totDocCRUD = 0, argsCrud = [], crudColecc = [], argsUpd = {}
    let listColecc = listServTar.map(recpago => ({...recpago}))

    let numeroRC = await nextVal('reccajas')
    numeroRC = numeroRC.toString()
// console.log(numeroRC, totRecibido, saldoPendiente)

//Coleccion PAGOCLIENTES
  if(totRecibido>saldoPendiente){
//Documento MAYOR VALOR PAGADO
//traer clase si todos los servicios de la tarifa son de la misma clase
    let claseServSig = claseServCli(data.tarifa.codigoTarifa, data.tarifa.servicios)
    argsUpd = rpArgsMvp(data.contrato, totRecibido, saldoPendiente, claseServSig)
    listColecc.push(argsUpd)
  }
//Documentos para coleccion
  let colecc = rpArgsPc(listColecc, dataChange, saldoPendiente, totRecibido, numeroRC,
    descrRecurso, numeroDocumUA, fechaHoraHoy, userLogin)
  let creaColecc = colecc.creaColecc
  let movColecc = colecc.movColecc

  //Actualizar base de datos
  let updColSI_ID = updColeccSI_ID(creaColecc, movColecc, createPagoClientes,
        editPagoClientesUpdDoc)
// console.log(updColSI_ID.crudColecc, updColSI_ID.argsCrud, updColSI_ID.totDocCRUD)
  await updColecc(updColSI_ID.crudColecc, updColSI_ID.argsCrud, updColSI_ID.totDocCRUD)
//FIN Coleccion PAGOCLIENTES

//Coleccion HISTCLIENTES
//Documento para coleccion
  let relacion = numeroRC, movimiento = "Pago", detalle = "A saldo pendiente", valor = totRecibido
  let descripcion = descrRecurso!==""?`Tercero: ${descrRecurso}`:"Oficina"
  colecc = argsHc(data.contrato, relacion, valor, userLogin, descripcion, detalle, movimiento, fechaHoraHoy)
  creaColecc = colecc.creaColecc

//Actualizar base de datos
  let creaColeccMany = [], creaColeccMany1 = []
  creaColecc.forEach((elemento, ii) => {
    creaColeccMany.push(elemento)
  })
  creaColeccMany1.push({histcliente: creaColeccMany})

  let updColMANY = updColeccMANY(creaColeccMany1, createHistClienteMany)
  await updColecc(updColMANY.crudColecc, updColMANY.argsCrud, updColMANY.totDocCRUD)
//FIN Coleccion HISTCLIENTES

  let saldoCl = parseInt(saldoPendiente, 10) - parseInt(totRecibido, 10)

  let saldoClAjCero = saldoCl, hacerAjCero = false
  if(Math.abs(saldoCl)<=ajCero&&saldoCl!==0&&ajCero>0){
//Ajuste a CERO por parametro ajCero
    saldoClAjCero = 0
    hacerAjCero = true
  }
// console.log(saldoClAjCero, hacerAjCero)

//Coleccion MOVCLIENTES
//Documento para coleccion
  colecc = rpArgsMc(data.contrato, numeroRC, totRecibido, userLogin, descrRecurso, numeroDocumUA,
    saldoCl, fechaHoraHoy)
  creaColecc = colecc.creaColecc

//Actualizar base de datos
  creaColeccMany = []
  creaColeccMany1 = []
  creaColecc.forEach((elemento, ii) => {
    creaColeccMany.push(elemento)
  })
  creaColeccMany1.push({movcliente: creaColeccMany})

  updColMANY = updColeccMANY(creaColeccMany1, createMovClientesMany)
  await updColecc(updColMANY.crudColecc, updColMANY.argsCrud, updColMANY.totDocCRUD)
//FIN Coleccion MOVCLIENTES

//Detalle MOVCLIENTES
//Actualizar el valor pagado y valor recibido del detalle de movclientes
//No se crea .js porque actualiza la variable hacerRX
  // let fechaHoy = new Date()
  // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
  // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
  let fechaHoy = fechaHoraHoy.substr(0, 10)
  let horaHoy = fechaHoraHoy.substr(11, 8)

  let hacerRX = true, numDX = data.numeroOdeDX
  if(numDX===0){
    hacerRX = false
  }

  movColecc = []
  listServTar.forEach((elemento1, ii) => {
    if(numDX>0&&elemento1.numeroOdeDX>0&&(!elemento1.valorRecibido||elemento1.valorRecibido===0)&&
      elemento1.valorTotal>0&&!hacerAjCero){
      hacerRX = false
    }
    if((elemento1.valorRecibido&&elemento1.valorRecibido!==0) || hacerAjCero){
      let valPagado = 0
      if(elemento1.valorPagado){
        valPagado = parseInt(elemento1.valorPagado, 10) + parseInt(elemento1.valorRecibido, 10)
      }else{
        valPagado = parseInt(elemento1.valorRecibido, 10)
      }
      let valParaHacerRX = parseInt(valPagado, 10) + parseInt(valorparaPermRX, 10)
      // if(numDX>0&&elemento1.numeroOdeDX>0&&valPagado<elemento1.valorTotal&&elemento1.valorTotal>0){
      if(numDX>0&&elemento1.numeroOdeDX>0&&valParaHacerRX<elemento1.valorTotal&&elemento1.valorTotal>0){
        hacerRX = false
      }

      let valorPagadoDet = valPagado, valorPendienteDet = elemento1.valorTotal - valPagado
      if(hacerAjCero){
        //Ajuste a CERO por parametro ajCero
        valorPagadoDet = elemento1.valorTotal
        valorPendienteDet = 0
      }

      argsUpd = {
        "contrato": data.contrato,
        "_id": elemento1._id,
        "procesado": elemento1.procesado,
        "concepto": elemento1.concepto,
        "numeroFra": elemento1.numeroFra,
        "numeroRC": elemento1.numeroRC,
        "numeroCE": elemento1.numeroCE,
        "numeroOdeDX": elemento1.numeroOdeDX,
        "documento": elemento1.documento,
        "fechaUltPago": fechaHoy,
        "valorUltPago": elemento1.valorRecibido,
        "valorPagado": valorPagadoDet,
        "valorPendiente": valorPendienteDet
      }
      // console.log(argsUpd)
      movColecc.push(argsUpd)
    }
  })
//FIN Detalle MOVCLIENTES

//HACER RX
  let actServCli = [], movCliRX = []
  if(hacerRX){
    let saldoClCC = saldoCl

    if(data.tarifa.codigoTarifa){
// //PARA CUANDO SE FACTURA UN MES ANTERIOR
//     let ultMF = ""
//     let ultPF = this.props.allProcFact1.allProcFact.filter(elemento => elemento.cicloFact===data.cicloFact)
//     if(ultPF.length>0){
//       ultMF = ultPF[ultPF.length-1].mes
//     }
// //FIN PARA CUANDO SE FACTURA UN MES ANTERIOR

//PROCESO CREAR DOCUM EN MOVIMCLIENTE DE DESCUENTO (SI YA SE FACT) O CARGUE (SI NO SE HA FACT) POR DX
  
//traer el número de días del mes
      const numDM = getNumDiasMes(fechaHoy.substr(5, 2), fechaHoy.substr(0, 4))
      const numDF = numDM - parseInt(fechaHoy.substr(8, 2), 10) + 1
  
      let ddI = parseInt(fechaHoy.substr(8, 2), 10) - 1
  
      let elemento3 = []
      let difSaldoNeg = 0, valorPagNeg = 0
//verificar si el valor total a descontar (neg) es mayor que el saldocl, si es asi, la dif se cruza con
//los cargos positivos
//      if(data.tarifa.codigoTarifa){
      elemento3 = data.tarifa
      elemento3.servicios.forEach((elemento1, i) => {
        if(elemento1.estadoServicio==="D"){
          let numDNvo = numDM - ddI
          let valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
          
          if(valorServ<0){
            valorPagNeg += valorServ
          }
        }
      })
      if(saldoCl<(valorPagNeg * -1)){
        difSaldoNeg = (valorPagNeg * -1) - saldoCl
      }
//      }

// console.log("Hacer RX")

      elemento3 = []

//      if(data.tarifa.codigoTarifa){
      elemento3 = data.tarifa
// console.log(elemento3)
      elemento3.servicios.forEach((elemento1, i) => {
      // if(elemento1.codigoServicio===elemento.codigoServicio&&elemento1.estadoServicio==="D"){
        if(elemento1.estadoServicio==="D"){
//Si esta DX => crear movcliente => siempre carga porque al dx se le descontó
        // let listServCargoFra = []
          let numDNvo = numDM - ddI
          let valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
          let valorAntesI = Math.round((elemento1.valorAntesImptos / numDM) * numDNvo)

          let valorPag = 0
          if(difSaldoNeg>0&&valorServ>0){
            if(difSaldoNeg-valorServ>=0){
              valorPag = valorServ
            }else{
              valorPag = difSaldoNeg
            }
            difSaldoNeg -= valorPag
          }

          if(saldoCl<0&&valorServ>0){
            if(saldoCl+valorServ>0){
              valorPag = saldoCl * -1
            }else{
              valorPag = valorServ
            }
          }
          if(valorServ<0){
            valorPag = valorServ
          }                

          if(elemento1.numeroServicios!==0){
            if(valorServ!==0){
//Traer los documentos para MOVCLIENTES
              colecc = rpArgsRx(data, elemento1, saldoCl, valorServ, valorAntesI, ultMF, listColeccRPCC,
                valorPag, numDF, numDM, userLogin, fechaHoraHoy)
              creaColecc = colecc.creaColecc
              saldoCl = colecc.saldoCl
//FIN Traer los documentos para MOVCLIENTES

              creaColecc.forEach((elementoDX, ii) => {
//                    if(this.props.getParametro.getParametro.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
                movCliRX.push(elementoDX)
//                    }else{
//                      movCli.push(elementoDX)
//                    }
              // console.log("77")

                argsUpd = {}
                argsUpd['tipoAct'] = "EditarServDX"
                argsUpd['contrato'] = data.contrato
                argsUpd['tarifa'] = { codigoTarifa: data.tarifa.codigoTarifa, servicios: 
                                  [{"codigoServicio": elementoDX.codigoServicio,
                                    "estadoServicio": "A"}]}
                actServCli.push(argsUpd)
              })
            }
          }
        }
      })

//Actualizar base de datos proceso HACER RX
      if(movCliRX.length>0){
        let movCliRXMany = [], movCliRXMany1 = []
        movCliRX.forEach((elemento, ii) => {
          movCliRXMany.push(elemento)
        })
        movCliRXMany1.push({movcliente: movCliRXMany})

        updColMANY = updColeccMANY(movCliRXMany1, createMovCliCCMany)
        await updColecc(updColMANY.crudColecc, updColMANY.argsCrud, updColMANY.totDocCRUD)
      }
      let actServCliMany = [], actServCliMany1 = []
      actServCli.forEach((elemento, ii) => {
        actServCliMany.push(elemento)
      })
      actServCliMany1.push({cliente: actServCliMany})

      updColMANY = updColeccMANY(actServCliMany1, editClienteUpdDocMany)
      await updColecc(updColMANY.crudColecc, updColMANY.argsCrud, updColMANY.totDocCRUD)
//FIN Actualizar base de datos proceso HACER RX
    }
//FIN PROCESO CREAR DOCUM EN MOVIMCLIENTE DE DESCUENTO (SI YA SE FACT) O CARGUE (SI NO SE HA FACT) POR DX
    saldoCl = saldoClCC

    //Coleccion HISTCLIENTES
    //Documento para coleccion
    relacion = numeroRC
    movimiento = "Pago"
    detalle = "Se hace RX por pago"
    valor = totRecibido
    descripcion = descrRecurso!==""?`Tercero: ${descrRecurso}`:"Oficina"
    colecc = argsHc(data.contrato, relacion, valor, userLogin, descripcion, detalle, movimiento, fechaHoraHoy)
    creaColecc = colecc.creaColecc

    //Actualizar base de datos
    creaColeccMany = []
    creaColeccMany1 = []
    creaColecc.forEach((elemento, ii) => {
      creaColeccMany.push(elemento)
    })
    creaColeccMany1.push({histcliente: creaColeccMany})

    updColMANY = updColeccMANY(creaColeccMany1, createHistClienteMany)
    await updColecc(updColMANY.crudColecc, updColMANY.argsCrud, updColMANY.totDocCRUD)
    //FIN Coleccion HISTCLIENTES
  }
//FIN HACER RX


//    if(movCli.length>0){
  creaColecc = []
  let numOdeDX = 0
  if(!hacerRX&&data.numeroOdeDX>0){
    numOdeDX = data.numeroOdeDX
  }
  argsUpd = {}
  argsUpd = {
    "tipoAct": "EditarCliDX",
    "contrato": data.contrato,
    "numeroOdeDX": numOdeDX,
  }
  creaColecc.push(argsUpd)

//Actualizar en clientes el numeroOdeDX
  creaColeccMany = []
  creaColeccMany1 = []
  creaColecc.forEach((elemento, ii) => {
    creaColeccMany.push(elemento)
  })
  creaColeccMany1.push({cliente: creaColeccMany})

  updColMANY = updColeccMANY(creaColeccMany1, editClienteMany)
  await updColecc(updColMANY.crudColecc, updColMANY.argsCrud, updColMANY.totDocCRUD)
//FIN Actualizar en clientes el numeroOdeDX


//ACTUALIZAR DIASMORA
//para calcular diasmora =>
//diasMora = movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta?movim.pagueHasta.substr(0, 10):movim.pagueHasta).getTime()) / (1000*60*60*24), 10)):0
// let movimDX1 = await listServTar.map(movim => ({
//   ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta?movim.pagueHasta.substr(0, 10):movim.pagueHasta).getTime()) / (1000*60*60*24), 10)):0}))
  let actCli = [], fechaPH = null
  if(saldoCl>0){
    let fechaMora = new Date()
    fechaMora = (fechaMora.getFullYear()) + '-' + ((fechaMora.getMonth()+1)<10?'0'+(fechaMora.getMonth()+1):(fechaMora.getMonth()+1)) + '-' + (fechaMora.getUTCDate()<10?'0'+fechaMora.getUTCDate():fechaMora.getUTCDate())
    let movimDX1 = await listServTar.map(movim => ({
      ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta.substr(0, 10)).getTime()) / (1000*60*60*24), 10)):0}))
    let fechaHoy1 = new Date()
    let diasHoy = fechaHoy1.getUTCDate()
    let mesHoy = fechaHoy1.getMonth()+1

    let diasMora = 0, diasMoraMayor = 0
    await movimDX1.forEach((movim, ii) => {
    // console.log(movim)
      diasMora = 0
      if(movim.pagueHasta&&movim.valorTotal>(movim.valorPagado+movim.valorRecibido)&&movim.valorTotal>0){
        if((movim.codigoServicio==="SISTV"||movim.codigoServicio==="SINET")&&data.cargoMensual>0){
//Math.ceil redondea al entero por encima
          let mesesM = Math.ceil((movim.valorTotal - (movim.valorPagado+movim.valorRecibido)) / data.cargoMensual)
          if(movim.codigoServicio==="SISTV"){
            diasMora = ((mesHoy-6+mesesM) * 30) + diasHoy
          }else{
            diasMora = ((mesHoy-5+mesesM) * 30) + diasHoy - 15
          }
// console.log(movim.contrato, movim.codigoServicio, mesesM, diasMora)
        }else{
          diasMora = movim.diasMora
        }
      }
      if(diasMora>diasMoraMayor||(diasMora<0&&diasMoraMayor===0)){
        diasMoraMayor = diasMora
      }
    })
    if(diasMoraMayor!==0){
      let fechaInicio = new Date(fechaMora).getTime();
      let fechaFin = new Date(fechaInicio-(diasMoraMayor*1000*60*60*24)+(1000*60*60*24));
      fechaPH = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
    }else{
      fechaPH = null
    }
  }else{
    fechaPH = null
  }
  argsUpd = {}
  argsUpd = {
    "tipoAct": "EditarCliPagueHasta",
    "contrato": data.contrato,
    "pagueHasta": fechaPH,
  }
  actCli.push(argsUpd)
//FIN ACTUALIZAR DIASMORA

//ACTUALIZAR ARCHIVO DE RECAUDO => procesado = "S"
let actArchRdo = []
  argsUpd = {}
  argsUpd = {
    "_id": elementoArchRdo._id,
    "procesado": "S",
  }
  actArchRdo.push(argsUpd)

  let estCl = data.estadoCliente
  let ultFRX = data.fecgaUltRX

  if(data.estadoCliente!=="ACTIVO"&&hacerRX){
    estCl = "ACTIVO"
    ultFRX = fechaHoy
  }

  let actColecc = []
//actualizar saldo y estado en clientes
  argsUpd = {
    "tipoAct": "EditarCliOdeS",
    "_id": data._id,
    "estadoCliente": estCl,
    "cargoMensual": data.cargoMensual,
    "saldoPendiente": saldoClAjCero,
  }
  actColecc.push(argsUpd)

// console.log(data)

  let actFechas = []
  argsUpd = {
    "tipoAct": "EditarFechCli",
    "_id": data._id,
    "fechaUltOSAb": data.fechaUltOSAb,
    "fechaPrimeraActivacion": data.fechaPrimeraActivacion,
    "fechaUltDX": data.fechaUltDX,
    "fecgaUltRX": ultFRX,
    "estadoAnterior": data.estadoAnterior,
    "fechaUltOSCe": data.fechaUltOSCe,
    "fechaUltPago": fechaHoy,
    "valorUltPago": totRecibido,
  }
  actFechas.push(argsUpd)

//Actualizar BD
  numDocCRUD = 0
// totDocCRUD = movColecc.length + 2
  totDocCRUD = movColecc.length + 4
  argsCrud = []
  crudColecc = []
  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'NO_CRUD'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    crudColecc.push(editMovClientes)
  }

  argsCrud[numDocCRUD] = actFechas[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = editCliente

  numDocCRUD += 1

  argsCrud[numDocCRUD] = actCli[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = editCliente

  numDocCRUD += 1

  argsCrud[numDocCRUD] = actArchRdo[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = editRdoTerc

  numDocCRUD += 1

// console.log(movColecc)
  movColecc.forEach((elemento1, ii) => {
    argsCrud[numDocCRUD] = elemento1
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

    numDocCRUD += 1
  })
  
  argsCrud[numDocCRUD] = actColecc[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = editCliente

  // numDocCRUD += 1

// console.log(crudColecc)
// console.log(argsCrud)
// console.log(totDocCRUD)
  await updColecc(crudColecc, argsCrud, totDocCRUD)

  if(hacerAjCero){
//HACER AJUSTE A SALDO CERO
    let numeroAjuste = await nextVal('aju')
    numeroAjuste = numeroAjuste.toString()
    let tipoAjuste = "", clase = "", origen = ""

    if(saldoCl<0){
      tipoAjuste = "AP"
      origen = `Ajuste positivo ${numeroAjuste}`
      clase = "Ajuste positivo"
    }else{
      tipoAjuste = "AN"
      origen = `Ajuste negativo ${numeroAjuste}`
      clase = "Ajuste negativo"
    }

    let argsAddAj = {}
    creaColecc = []
    argsAddAj['tipoAjuste'] = tipoAjuste
    argsAddAj['numeroAjuste'] = numeroAjuste
    argsAddAj['fechaAjuste'] = fechaHoy
    argsAddAj['contrato'] = data.contrato
    argsAddAj['concepto'] = "Ajuste a saldo cero"
    argsAddAj['valorAjuste'] = saldoCl
    creaColecc.push(argsAddAj)

    let creaHC = []
    let argsAddHC = {
      "fechaHistCliente": fechaHoy + ' ' + horaHoy,
      "contrato": data.contrato,
      "movimiento": "Ajuste",
      "descripcion": clase,
      "detalle": "Ajuste a saldo cero",
      "relacion": numeroAjuste,
      "valor": saldoCl,
      "usuarioCreate": sessionStorage.getItem('userLogin'),
    }
    creaHC.push(argsAddHC)

    let claseServSig = "NoDefinida", claseServSig1 = ""
    if(data.tarifa.codigoTarifa){
      claseServSig1 = data.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
      claseServSig = data.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
      data.tarifa.servicios.forEach((elemento, _id) => {
        if(claseServSig1!==claseServSig){
          claseServSig = "NoDefinida"
        }
      })
    }
    // console.log(claseServSig)
    
    let creaColeccMC = []
    let valorMC = saldoCl * -1
    let argsAddMC = {
      "contrato": data.contrato,
      "fechaMov": fechaHoy,
      "tipo": "C",
      "subTipo": tipoAjuste,
      "procesado": "S",
      "nombreResumido": "Ajuste a saldo cero",
      "descripcionServicio": "Ajuste",
      "descrClaseServ": claseServSig,
      "concepto": "Ajuste",
      "origen": origen,
      "saldoCliente": 0,
      "valorTotal": valorMC,
      "valorAntesImptos": valorMC,
      "documento": numeroAjuste,
      "valorPagado": valorMC,
      "valorPendiente": 0,
      "numeroOdeDX": 0,
    };
    creaColeccMC.push(argsAddMC)

//Crear el ajuste, histclientes y movclientes
    let creaHCMany = [], creaHCMany1 = []
    creaHC.forEach((elementoHC, ii) => {
      creaHCMany.push(elementoHC)
    })
    creaHCMany1.push({histcliente: creaHCMany})

    numDocCRUD = 0
    totDocCRUD = 3
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }

    argsCrud[numDocCRUD] = creaColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = createAjuste

    numDocCRUD += 1

    argsCrud[numDocCRUD] = creaHCMany1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = createHistClienteMany

    numDocCRUD += 1

    argsCrud[numDocCRUD] = creaColeccMC[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = createMovClientes

// console.log(argsCrud)
    await updColecc(crudColecc, argsCrud, totDocCRUD)
//FIN HACER AJUSTE A SALDO CERO
  }

  // console.log("fin", data.contrato)
}


// console.log(data.tarifa.descrTarifa, data.cicloFact, data)
// console.log(elemento)
// console.log(listColeccRP)
// console.log(listColeccRPCC)
// console.log(numeroDocum, descrRecurso, ultMF, totRecibido, saldoPendiente)

const contratoFin = data.contrato

return contratoFin

}

export default MainRdo

// export default compose(
//   // graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {contrato: "12", orden: '_id'}}}}),

//   // graphql(queries.mutation.editOdeS, {name:'editOdeS'}),

// )(MainRdo)
